import React from "react";

export default (props) => {
  return (
    <div>
      {props.has_randomization_platform_step_3_surrogate ? (
        <div
          dangerouslySetInnerHTML={{
            __html: props.randomization_platform_step_3_surrogate_content,
          }}
        />
      ) : (
        <div style={{ textAlign: "justify" }}>
          <h4 align="center">
            RESEARCH PARTICIPANT INFORMATION AND CONSENT FORM
          </h4>
          <h4 align="center">
            (Surrogate Deferred Consent and Regained Capacity following Deferral
            of Consent Process)
          </h4>
          <table style={{ width: "100%", textAlign: "left" }}>
            <tbody>
              <tr>
                <td style={{ width: "30%" }} valign="top">
                  Title of Study
                </td>
                <td style={{ width: "70%" }} valign="top">
                  Alteplase Compared to Tenecteplase in patients with Acute
                  Ischemic Stroke: QuICR & OPTIMISE Registry based Pragmatic
                  Randomized Controlled Trial
                </td>
              </tr>
              <tr>
                <td style={{ width: "30%" }} valign="top">
                  Protocol number
                </td>
                <td style={{ width: "70%" }} valign="top">
                  AcT 01.6 Original Protocol
                </td>
              </tr>
              <tr>
                <td style={{ width: "30%" }} valign="top">
                  Principal Investigator
                </td>
                <td style={{ width: "70%" }} valign="top">
                  <b>Dr. Jai Jai Shiva Shankar</b>
                  <br />
                  Rady Faculty of Health Sciences
                  <br />
                  University of Manitoba
                  <br />
                  Room 807K-JBRC/715 Mc Dermot Avenue
                  <br />
                  Winnipeg, MB R3E 3P5
                  <br />
                  Phone: +1-431-373-4164
                  <br />
                </td>
              </tr>
              <tr>
                <td style={{ width: "30%" }} valign="top">
                  Sponsor
                </td>
                <td style={{ width: "70%" }} valign="top">
                  <b>Dr. Bijoy Menon</b>
                  <br />
                  University of Calgary
                  <br />
                  Foothills Medical Center
                  <br />
                  1403 29th Street NW
                  <br />
                  Calgary, AB, T2N 2T9
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <p>
            This consent form, a copy of which has been given to you, is only
            part of the process of informed consent. It should give you the
            basic idea of what the research is about and what your participation
            will involve. If you would like more detail about something
            mentioned here, or information not included here, you should feel
            free to ask. Please take the time to read this carefully and to
            understand any accompanying information.
          </p>

          <p>
            <u>Purpose of Study</u>
          </p>
          <p>
            <i>
              If you, being the family member or partner, are acting as a
              representative to give consent for another person to participate
              in this study, “you” throughout this consent form refers to that
              individual (the subject). Your obligation is to try to determine
              what the individual would do if competent, or if the subject’s
              wishes cannot be determined, what you think is in the person’s
              best interest.
            </i>
          </p>
          <p>
            You are being asked to take part in this study because you have had
            an acute ischemic stroke. This happens when a clot blocks a blood
            vessel, reducing the blood supply to a part of your brain. When this
            happens, the affected part of the brain can be damaged, sometimes
            permanently.
          </p>
          <p>
            We know that a medication called Alteplase (tPA) can reduce brain
            damage from a stroke by dissolving the clot in the blocked artery.
            This helps to restore normal blood supply to the brain before it
            becomes permanently damaged. Alteplase is the usual treatment for
            stroke patients. Despite the benefits of Alteplase at reducing brain
            damage and disability in stroke patients, there are risks including
            brain bleeding. Tenecteplase (TNK) is a different clot-dissolving
            medication that is similar to Alteplase and is often used for
            patients who have a heart attack, where there is a clot blocking a
            blood vessel in the heart. Tenecteplase is not currently approved
            for use in acute stroke care but has shown very promising results in
            recent stroke studies.
          </p>
          <p>
            The Purpose of this study is to compare Alteplase with Tenecteplase
            for stroke treatment to determine if patients who receive
            Tenecteplase do as well as those who receive Alteplase, when
            followed out to 3 months after their stroke.
          </p>
          <p>
            Because a stroke is an emergency situation where every minute
            counts, and you may have been incapacitated at the time of your
            stroke, you were enrolled by deferral of consent, meaning that you
            received either Alteplase or Tenecteplase without first being asked.
            This process was designed in consultation with experts in research
            ethics and with stroke patients and was approved by your hospital’s
            research ethics board.
          </p>
          <p>
            If you consent to participate in this study, regular standard of
            care assessments will be performed, including routine follow up with
            your physician. A follow up visit at 3 months (roughly 90 days),
            would happen as in routine practice. An important part of this study
            is to see how patients have recovered and are functioning at 3
            months after their stroke. This assessment will be done through a
            telephone interview with research staff from the University of
            Calgary/Foothills Medical Centre. The interview will last about 5
            minutes. You will be called one time at 3 months (as close to 90
            days as possible, to a maximum of 120 days depending on your
            schedule). For participants who are not fluent in English, the
            services of an interpreter will be offered so as not to exclude
            anyone on the basis of language. If you are able and interested, we
            will also ask you to complete an online assessment to find out if
            there are any differences in memory or thinking between the groups
            of people who got the two drugs. You do not have to complete this
            online assessment to be part of the main study. After the 3-month
            assessment (phone call and online assessment) is finished, your
            participation in the study will be complete.
          </p>
          <br />

          <p>
            <u>Risks and Discomforts</u>
          </p>
          <p>
            All medical procedures involve some risk of injury. There may be
            risks associated with this study that are unknown and cannot be
            predicted, though all precautions will be taken to avoid this. Risks
            associated with standard care procedures such as CT and MRI scans,
            will be discussed by your physician.
          </p>
          <p>
            As the two drugs are chemically similar, Alteplase and Tenecteplase
            have similar side effects. The major risks are:
            <ol>
              <li>
                Bruising or bleeding from your injection site, nose or gums.
                Generally, such bleeding is easily controlled.
              </li>
              <li>
                Bleeding from the stomach or urinary tract. This is rare (less
                than 1 chance in 100), but may require specific treatment (such
                as surgery) or a blood transfusion.
              </li>
              <li>
                Bleeding (into the brain) risk is about a 1 in 20 chance, as per
                the Safe Implementation of Thrombolysis in Stroke (SITS)
                registry; this is the major side effect.
              </li>
              <li>
                Very rarely, Alteplase or Tenecteplase can cause a serious
                allergic reaction (about 1 in 10,000 treatments). This can lead
                to low blood pressure, airway swelling and obstruction. This
                could potentially be fatal, but there have been no deaths
                reported due to allergy with either drug. This reaction can be
                treated with medication.
              </li>
              <li>
                The risk to an unborn child is uncertain. If you are pregnant,
                you will only be allowed to participate in this study after
                consultation with an expert stroke physician.
              </li>
              <li>
                Baseline and 24-hour CT scans are part of standard stroke
                patient care and involve exposure of only a small amount of
                radiation in addition to the usual x-rays studies done in stroke
                patients.
              </li>
            </ol>
          </p>
          <br />

          <p>
            <u>Possible Benefits</u>
          </p>
          <p>
            If you agree to participate in this study, there may or may not be a
            direct medical benefit to you. Your participation will provide
            information about the study treatment(s) and stroke that may benefit
            others by helping to provide better future treatments for patients
            with stroke. Your stroke may be improved during the study but there
            is no guarantee of that. The possible benefits to you from taking
            part in this study are close monitoring of your stroke, general
            health status, and any symptoms that you may experience during the
            study.
          </p>
          <br />

          <p>
            <u>New Findings</u>
          </p>
          <p>
            You will receive any new information during the course of the study
            concerning significant treatment findings that may affect your
            willingness to continue your participation.
          </p>

          <p>
            <u>Confidentiality</u>
          </p>
          <p>
            During the study we will be collecting health data about you. We
            will do everything we can to make sure that this data is kept
            private. Sometimes, by law, we may have to release your information
            with your name so we cannot guarantee absolute privacy. However, we
            will make every legal effort to make sure that your health
            information is kept private.
          </p>
          <p>
            No data relating to this study that includes your name will be
            released to anyone outside of the research team, nor will it be
            published by the researchers. Your name, telephone number and/or
            email will be provided to the AcT Coordinating Centre located at the
            University of Calgary, to contact you for conducting the telephone
            assessment required as part of this study. Every effort will be made
            to ensure that all parties who receive your private information
            understand the need to keep this information confidential.
          </p>
          <p>
            During research studies, it is important that the data we get is
            accurate and ensure the study is carried out correctly. Authorized
            representatives from the University of Manitoba Bannatyne Campus
            Research Ethics Boards, Health Canada and / or other regulatory
            agencies may look at your identifiable medical/clinical study
            records, including this consent form, in confidence and only for
            purposes of quality assurance.
          </p>
          <p>
            By signing the consent form, you are giving permission for the study
            doctor/staff to collect, use and disclose information about you from
            a number of sources. Any health information that we get from any of
            these records will be limited to only what is needed for the study.
            These possible sources include your personal hospital electronic
            medical records, including EPR, the OPTIMISE registry, your hospital
            site, other health care providers that you may have seen in the past
            (i.e. your family doctor) or the Canadian Institute for Health
            Information (CIHI) databases. CIHI collects data from hospitals in
            Canada including information about how often Canadians go to the
            hospital, how long they stayed, what types of doctors they saw, and
            other information about these hospitalizations/emergency department
            (ED) visits. This information is stored in the CIHI clinical
            administrative databases, along with your health care number. Your
            name is not included in these databases.
          </p>

          <p>
            In order to locate information about your past and future
            hospitalizations or ED visits up until a year after enrolment, which
            may include hospitals other than where you were originally admitted
            at the time of your stroke, authorized personnel from the study
            hospitals or registries will provide your health care number
            directly to CIHI solely for the purpose of extracting your
            hospitalization records from its databases. CIHI will then provide
            these records back to the study investigators without the health
            care number, using an anonymized study identification number. The
            study investigators will add the CIHI data to the study data based
            on this study identification number.
          </p>

          <p>
            The signed consent form will be encrypted and electronically stored
            at the AcT Coordinating Centre located at the University of Calgary
            for review.
          </p>
          <p>
            After the study is done, we will still need to securely store your
            health data that was collected as part of the study. In Canada, the
            law says we have to keep the data stored for 25 years after the end
            of the study; after which the all the study data will be destroyed.
          </p>

          <p>
            A description of this clinical trial is available on
            <a
              href="http://www.ClinicalTrials.gov"
              target="_blank"
              rel="noopener noreferrer"
            >
              http://www.ClinicalTrials.gov
            </a>
            , as encouraged by Health Canada. This Web site will not include any
            information that can identify you. At most, the Web site will
            include a summary of the results. You can search this Web site at
            any time.
          </p>

          <p>
            <u>Compensation for Injury</u>
          </p>
          <p>
            In the event that you suffer injury as a result of participating in
            this research, no compensation will be provided for you by the
            University of Manitoba, or the Researchers. You still have all your
            legal rights. Nothing said here about treatment or compensation in
            any way alters your right to recover damages.
          </p>

          <p>
            <b>
              <u>Questions</u>
            </b>
          </p>

          <p>
            <b>
              You are free to ask any questions that you may have about your
              treatment and your rights as a research participant. If any
              questions come up during or after the study or if you have a
              research-related injury, contact the study doctor and the study
              staff: Dr. Jai Jai Shiva Shankar at 1-431-373-4164.
            </b>
          </p>
          <p>
            <b>
              For questions about your rights as a research participant, you may
              contact The University of Manitoba Biomedical Research Ethics
              Board at (204) 789-3389.
            </b>
          </p>
          <p>
            <b>
              Do not sign this consent form unless you have had a chance to ask
              questions and have received satisfactory answers to all of your
              questions.
            </b>
          </p>

          <p>
            <b>
              <u>Statement of Consent</u>
            </b>
          </p>
          <p>
            I have read this consent form. I have had the opportunity to discuss
            this research study with Dr. Jai Jai Shiva Shankar and or his study
            staff. I have had my questions answered by them in language I
            understand. The risks and benefits have been explained to me. I
            believe that I have not been unduly influenced by any study team
            member to participate in the research study by any statement or
            implied statements. Any relationship (such as employee, student or
            family member) I may have with the study team has not affected my
            decision to participate. I understand that I will be given a copy of
            this consent form after signing it. I understand that my
            participation in this clinical trial is voluntary and that I may
            choose to withdraw at any time. I freely agree to participate in
            this research study
          </p>
          <p>
            I understand that information regarding my personal identity will be
            kept confidential, but that confidentiality is not guaranteed. I
            authorize the inspection of my medical records by Dr. Bijoy Menon,
            University of Calgary, the Food and Drug Administration, the Health
            Protection Branch, government agencies in other countries, and The
            University of Manitoba Biomedical Research Ethics Board.
          </p>
          <p>
            By signing this consent form, I have not waived any of the legal
            rights that I have as a participant in a research study.
          </p>

          <br />
          <br />
          <br />
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/ConsentTypeWinnipeg/Texts/SurrogateElectronicText.js